'use client';

import { c as _c } from "react/compiler-runtime";
import { Tag, Megaphone, ShoppingBag, MapPin, Presentation, CalendarSearch, Briefcase, Handshake, Wine } from 'lucide-react';
import Link from 'next/link';
const examples = [
// {
//   icon: Tag,
//   title: 'Limited-Time Offer',
//   description: 'Run a targeted discount or bundle to drive first purchase and repeat trial.',
//   format: 'Consumer',
//   outcome: 'Trial + conversion',
//   color: 'bg-blue-100 text-blue-600',
// },
// {
//   icon: ShoppingBag,
//   title: 'Retail Demo Day',
//   description: 'Coordinate in-store demos with retail partners to drive immediate purchase.',
//   format: 'Consumer',
//   outcome: 'Trial + sales',
//   color: 'bg-purple-100 text-purple-600',
// },
// {
//   icon: MapPin,
//   title: 'Venue Pop-Up',
//   description:
//     'Feature your product in cafes, bars, or hospitality venues for organic discovery.',
//   format: 'Consumer',
//   outcome: 'Awareness + trial',
//   color: 'bg-cyan-100 text-cyan-600',
// },
{
  icon: Briefcase,
  title: 'Workplace Drops and Experiences',
  description: 'Deliver product samples directly to workplaces for lunchroom discovery, team tastings, and branded experiences.',
  format: 'Consumer',
  outcome: 'Trial + feedback',
  color: 'bg-rose-100 text-rose-600'
}, {
  icon: Handshake,
  title: 'Brand Collaborations',
  description: 'Partner with complementary brands on co-branded bundles, cross-promotions, or joint activations to reach new audiences.',
  format: 'Brand',
  outcome: 'Reach + credibility',
  color: 'bg-orange-100 text-orange-600'
}, {
  icon: Wine,
  title: 'Product Tastings',
  description: 'Host guided tasting sessions at markets, events, or retail locations to let consumers experience your product first-hand.',
  format: 'Consumer',
  outcome: 'Trial + conversion',
  color: 'bg-pink-100 text-pink-600'
}];
const links = [{
  href: '/spark',
  label: 'Get Inspired, Take Action →'
}, {
  href: '/opportunities',
  label: 'Live Opportunities →'
}
// { href: '/asks', label: 'Asks for Product →' },
// { href: '/for-places', label: 'Experiences and Free Products at your Place →' },
// { href: '/for-events', label: 'Free and Discounted Products at your Event →' },
];
export function HomeSparkSection() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="text-center mb-16"><h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-4">{"Sell More By Boosting Awareness & Trial"}</h2><p className="text-lg text-gray-500 max-w-xl mx-auto">The more people know about and try your product, the more you'll sell.</p><p className="text-lg text-gray-500 max-w-xl mx-auto">There are many things you can do to boost Awareness + Trial, Sizzle helps you with inspiration and action.</p></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">{examples.map(_temp)}</div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <section className="py-16 lg:py-20"><div className="container mx-auto px-4 sm:px-6 lg:px-8">{t0}{t1}<div className="flex flex-wrap items-center justify-center gap-4 mt-12">{links.map(_temp2)}</div></div></section>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
function _temp2(link) {
  return <Link key={link.href} href={link.href} className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-600 text-white font-semibold shadow-md hover:bg-primary-700 hover:shadow-lg transition-all duration-200 cursor-pointer">{link.label}</Link>;
}
function _temp(example) {
  return <div key={example.title} className="group rounded-2xl border border-gray-200 bg-white p-8 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300"><h3 className="text-xl font-bold text-gray-900 mb-2">{example.title}</h3><p className="text-gray-500 text-sm mb-6 leading-relaxed">{example.description}</p><div className="flex items-center justify-between text-xs text-gray-400 pt-4 border-t border-gray-100"><span className="uppercase tracking-widest font-bold">{example.format}</span><span className="font-semibold text-primary-600">{example.outcome}</span></div></div>;
}
function BusinessMarketplaceHeading() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="container mx-auto px-4 py-8 text-center sm:px-6 lg:px-8"><h2 className="mx-auto max-w-2xl text-lg font-extrabold leading-tight text-gray-900 mb-4">Want more people to know, try and buy your products, or attract more customers into your stores?</h2></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}